import { useState } from 'react';
import { Tabs } from 'antd';
import { useLocation, useHistory } from 'react-router-dom';
import ExpendituresList      from './sn_expenditures/List';
import BeneficiariesList     from './sn_beneficiaries/List';
import BudgetAllocationsList from './sn_budget_allocations/List';
import PurposesList          from './sn_purposes/List';
import ApprovalWorkflow      from './sn_expenditures/ApprovalWorkflow';

const { TabPane } = Tabs;

const TABS = [
  { key: 'expenditures',       label: 'Expenditures',       Component: ExpendituresList },
  { key: 'beneficiaries',      label: 'Beneficiaries',      Component: BeneficiariesList },
  { key: 'budget-allocations', label: 'Budget Allocations', Component: BudgetAllocationsList },
  { key: 'purposes',           label: 'Purpose Categories', Component: PurposesList },
  { key: 'approval-workflow',  label: 'Approval Workflow',  Component: ApprovalWorkflow },
];

export default function ExpenditureMgmt() {
  const location = useLocation();
  const history  = useHistory();
  const params   = new URLSearchParams(location.search);
  const [active, setActive] = useState(params.get('tab') || 'expenditures');

  const switchTab = (key) => {
    setActive(key);
    history.replace(`/expenditure-mgmt?tab=${key}`);
  };

  const ActiveComponent = TABS.find(t => t.key === active)?.Component || ExpendituresList;

  return (
    <div style={{ background: '#f0f2f5', minHeight: '100vh' }}>
      <div style={{ background: '#fff', borderBottom: '2px solid #e2e8f0', padding: '0 24px' }}>
        <Tabs
          activeKey={active}
          onChange={switchTab}
          style={{ marginBottom: 0 }}
          tabBarStyle={{ marginBottom: 0 }}
        >
          {TABS.map(t => <TabPane tab={<span style={{ fontWeight: 600, fontSize: 13 }}>{t.label}</span>} key={t.key} />)}
        </Tabs>
      </div>
      <div style={{ padding: '20px 24px' }}>
        <ActiveComponent />
      </div>
    </div>
  );
}
